import { EmptyPlaylist } from '@/constant/imgImport';
import { PATH_NAME } from 'configs/pathName';
import Tooltips from 'design-system/components/Tooltips/Tooltips';
import { Typography } from 'design-system/components/Typography';
import Link from 'next/link';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { TDoccenLibraryPlaylist } from './types';

const Playlist = forwardRef<HTMLAnchorElement, TDoccenLibraryPlaylist>(
  ({ data, ...props }, ref) => {
    const { thumbnail, numberOfComprisingContents, title, author, price } =
      data;

    return (
      <Link
        href={{
          pathname: PATH_NAME.LIBRARY_COLLECTION_DETAIL,
          query: {
            cid: data.playlistId,
          },
        }}
        passHref
      >
        <a ref={ref} className={props.className}>
          <div
            {...props}
            className={twMerge(
              'flex flex-col space-y-2 rounded-[8px] border border-border_disabled transition-all ease-linear',
              props.disabled
                ? 'bg-Action/DisabledBackground'
                : 'cursor-pointer bg-Other/White hover:bg-Action/Hover focus:border-Primary/Main active:border-Primary/Main active:bg-Action/DC/Selected',
              props.className
            )}
          >
            <div className="flex justify-center rounded-[7px]">
              <img
                src={thumbnail || EmptyPlaylist}
                alt="collection thumbnail"
                className="aspect-[1.75] w-full rounded-lg"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="flex h-full flex-col justify-between gap-1 px-2 pb-2">
              <Tooltips title={title}>
                <Typography
                  variant="heading4"
                  className={[
                    'line-clamp-2 flex-1 leading-[inherit]',
                    props.disabled && 'text-Text/Lightbackground/Disabled',
                  ].join(' ')}
                >
                  {title}
                </Typography>
              </Tooltips>
              <div>
                <Typography
                  variant="input-label"
                  className="mt-auto line-clamp-1 text-Text/Lightbackground/Secondary"
                >
                  {numberOfComprisingContents} nội dung
                </Typography>
                <Typography
                  variant="input-label"
                  className="line-clamp-1 text-Text/Lightbackground/Secondary"
                >
                  {author.title && `${author.title}. `}
                  {author.name}
                </Typography>
              </div>
              {/* <Divider />
        <Typography
          variant="heading3"
          className={[
            'text-Success/Main',
            props.disabled && 'text-Text/Lightbackground/Disabled',
          ].join(' ')}
        >
          {price ? `${price} VNĐ` : 'Miễn phí'}
        </Typography> */}
            </div>
          </div>
        </a>
      </Link>
    );
  }
);

export default Playlist;
